import axiosInstance from "../../../helpers/api";

export const getAllPayments = (body) => {
  return axiosInstance.get("/superadmin/payment-subjects", body);
};
export const getPaymentException = (body) => {
  return axiosInstance.get("/admin/payment_exceptions", body);
};

export const editPayments = (formData) => {
  return axiosInstance.put(
    `/superadmin/payment-subjects/${formData.id}`,
    formData.formData || formData.formdata
  );
};

export const createPayments = (formData) => {
  return axiosInstance.post("/superadmin/payment-subjects", formData);
};

export const createVoucher = (formData) => {
  return axiosInstance.post("/admin/vouchers", formData);
};

export const deletePayment = (id) => {
  return axiosInstance.delete(`/superadmin/payment-subjects/${id}`);
};
